import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@mantine/core';
import AppStack from '../../common/AppStack';
import AppImage from '../../common/AppImage';
import PrintDesignEditorCanvasControls from './PrintDesignEditorCanvasControls';
import PrintDesignEditorCanvasInfoCard from './PrintDesignEditorCanvasInfoCard';
import PrintDesignTemplatePositionControls from './PrintDesignTemplatePositionControls';
import PrintDesignEditorToolbarMenu from './PrintDesignEditorToolbarMenu';
import PrintDesignEditorVariantDesignControls from './PrintDesignEditorVariantDesignControls';

const PrintDesignEditorCanvasDisplay = ({
  canvasRef,
  canvasOverlayRef,
  formState,
  printTemplateState,
  ecomExternalProduct,
  printTemplate,
  setFormState,
  onSwitchPrintImagePosition,
  canvasController,
  toolbarMenuState,
  setToolbarMenuState,
  loading
}) => {
  const showPreview = formState.printPreview?.showPreview;

  return (
    <AppStack
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {toolbarMenuState.isOpen && (
        <AppStack
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: 350,
            height: '100%',
            backgroundColor: '#FFF',
            borderRight: 'solid 1px lightgrey',
            zIndex: 10
          }}
        >
          <PrintDesignEditorToolbarMenu
            action={toolbarMenuState.action}
            canvasController={canvasController}
            onClose={() =>
              setToolbarMenuState({
                ...toolbarMenuState,
                isOpen: false
              })
            }
          />
        </AppStack>
      )}

      <AppStack
        onContextMenu={(e) => {
          e.preventDefault();
        }}
        style={{
          height: '100%',
          width: '100%',
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: 0
        }}
      >
        <canvas
          ref={canvasRef}
          height="100%"
          id="print-design-canvas"
          style={{
            width: '100%',
            height: '100%',
            pointerEvents: 'all'
          }}
          width="100%"
        />
      </AppStack>
      <AppStack
        onContextMenu={(e) => {
          e.preventDefault();
        }}
        style={{
          height: '100%',
          width: '100%',
          pointerEvents: 'none',
          position: 'absolute',
          top: 0,
          left: 0
        }}
      >
        <canvas
          ref={canvasOverlayRef}
          height="100%"
          id="print-design-canvas-overlay"
          style={{
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
          }}
          width="100%"
        />
      </AppStack>
      {loading && (
        <AppStack
          style={{
            height: '100%',
            width: '100%',
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor:
              printTemplateState.loadingImageUrls.length > 0
                ? 'none'
                : '#F0F0F0'
          }}
        >
          <Loader color="dark" size={60} />
        </AppStack>
      )}
      {showPreview && (
        <AppStack
          style={{
            height: '100%',
            width: '100%',
            pointerEvents: 'all',
            position: 'absolute',
            top: 0,
            left: 0,
            backgroundColor: '#F0F0F0',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'auto'
          }}
        >
          <AppStack style={{ backgroundColor: '#FFF', padding: 0 }}>
            <AppImage
              src={formState.printPreview?.previewImage}
              style={{ backgroundColor: '#FFF' }}
            />
          </AppStack>
        </AppStack>
      )}
      <PrintDesignEditorVariantDesignControls
        canvasController={canvasController}
        ecomExternalProduct={ecomExternalProduct}
        formState={formState}
        loading={loading}
        printTemplate={printTemplate}
        printTemplateState={printTemplateState}
        setFormState={setFormState}
      />

      <PrintDesignEditorCanvasInfoCard
        ecomExternalProduct={ecomExternalProduct}
        formState={formState}
        printTemplate={printTemplate}
        printTemplateState={printTemplateState}
        setFormState={setFormState}
      />
      <PrintDesignTemplatePositionControls
        ecomExternalProduct={ecomExternalProduct}
        onSwitchPrintImagePosition={onSwitchPrintImagePosition}
        printTemplateState={printTemplateState}
      />
      <PrintDesignEditorCanvasControls
        canvasController={canvasController}
        canvasOverlayRef={canvasOverlayRef}
        loading={formState.loading}
        printTemplateState={printTemplateState}
        setToolbarMenuState={setToolbarMenuState}
        toolbarMenuState={toolbarMenuState}
      />
    </AppStack>
  );
};

PrintDesignEditorCanvasDisplay.propTypes = {
  canvasController: PropTypes.object.isRequired,
  canvasOverlayRef: PropTypes.object.isRequired,
  canvasRef: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
  onSwitchPrintImagePosition: PropTypes.func.isRequired,
  printTemplateState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setToolbarMenuState: PropTypes.func.isRequired,
  toolbarMenuState: PropTypes.object.isRequired,
  ecomExternalProduct: PropTypes.object,
  loading: PropTypes.bool,
  printTemplate: PropTypes.object
};

export default PrintDesignEditorCanvasDisplay;
